<template>
  <div style="width: 100%">
    <!--列表-->
    <el-table
      size="mini"
      stripe
      border
      :data="tableData"
      highlight-current-row
      expand-on-click-node="false"
      style="width: 100%"
    >
      <el-table-column prop="Channel" label="订单" width="150">
        <template slot-scope="scope">
          <span
            type="info"
            style="
              cursor: pointer;
              font-size: 14;
              font-weight: bold;
            "
            @click="showInfo(scope.row)"
            >{{ scope.row.OrderID }}</span
          >
          <!-- <el-tag type="info" v-if="scope.row.Channel == 0">未知</el-tag>
          <el-tag type="warning" v-if="scope.row.Channel == 1">三方平台</el-tag>
          <el-tag type="primary" v-if="scope.row.Channel == 2">点评/美团</el-tag>
          <br /> -->
          <div>{{ scope.row.Tenant.Name }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="Mobile" label="下单用户" width="140">
        <template slot-scope="scope">
          <span type="success">{{ scope.row.UserName }}</span
          ><br />
          <span type="warning">{{
            scope.row.UserMobile | scope.row.UserPhone
          }}</span>
          <br />
          <span type="info">{{
            format.dateTimeFormat(scope.row.InsertTime)
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="UserAddress" label="上门信息" min-width="180">
        <template slot-scope="scope">
          <div v-if="scope.row.UserAddress && scope.row.UserAddress.Key">
            <span style="color: chocolate"> {{ scope.row.UserAddress.receiver_name }}</span>
            <span style="color: chocolate">{{
              scope.row.UserAddress.receiver_mobile
                ? scope.row.UserAddress.receiver_mobile
                : scope.row.UserAddress.receiver_phone
            }}</span
            ><i
              @click="onCopy(scope.row, false)"
              style="cursor: pointer; font-size: 18px; color: chocolate"
              class="el-icon-s-promotion"
            />
            <i
              @click="onCopy(scope.row, true)"
              style="cursor: pointer; font-size: 18px; color: chocolate"
              class="el-icon-position"
            />
            <br />
            <div style="color: chocolate;font-weight: bolder;">
            {{ format.dateTimeFormat(scope.row.BeginTime) }}
          </div>  
            <span
              type="info"
              style="
                cursor: pointer;
                color: chocolate;
              "
              @click="showInfo(scope.row)"
            >
              {{ scope.row.UserAddress.receiver_address }}</span
            >
          </div>
          <span 
              style="
                color: chocolate;
              "
            >{{ scope.row.Quantity }}*{{ scope.row.ProductName }}</span
          >
        </template>
      </el-table-column>
      <el-table-column prop="Duration" label="金额/利润" width="180">
        <template slot-scope="scope">
          <el-tag type="warning" v-if="scope.row.Duration">{{
            scope.row.Duration
          }}</el-tag>
          <div style="font-weight:bold;color:black;">总额：{{ scope.row.TotalAmount }}</div>
          <div v-if="scope.row.PromoAmount" style="color:#4caf50;font-weight:bold;">优惠：{{ scope.row.PromoAmount }}</div>
          <div v-if="scope.row.AddAmount" style="color:#FF0000;font-weight:bold;">加费：{{ scope.row.AddAmount }}</div>
          <div
            v-if="
              scope.row.OrderStatus == 40 ||
              scope.row.OrderStatus == 50 ||
              scope.row.OrderStatus == 70
            "
           style="color:#9C27B0; font-weight: bold"
          >
            利润：{{ calculateLiRun(scope.row) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="Worker" label="派单信息" width="200">
        <template slot-scope="scope">
          <div v-if="scope.row.Worker && scope.row.Worker.Key">
            
            <image-uploader
              class="el-icon-s-custom"
            />
            <span 
              >{{ scope.row.Worker.Name }}/{{ scope.row.Worker.Mobile }}</span
            ><br />
            <i
              class="el-icon-money"
            /><span 
              >{{ scope.row.WorkerCommission }}+{{ scope.row.WorkerBonos }}={{
                scope.row.WorkerCommission + scope.row.WorkerBonos
              }}</span
            ><br />
            <i class="el-icon-s-promotion"></i>
            <span>
              {{ format.dateTimeFormat(scope.row.DispatchDate) }}</span
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="OrderStatus" label="订单状态" width="120">
        <template slot-scope="scope">
          <!--待接单-->
          <div
            v-if="scope.row.OrderStatus == 10"
            style="color:#4CAF50;font-weight:bold;"
          >
            {{ format.orderStatusFormat(scope.row.OrderStatus) }}
          </div>
          <!--已接单-->
          <div v-if="scope.row.OrderStatus == 20" style="color:#2196F3;font-weight:bold;">
            {{ format.orderStatusFormat(scope.row.OrderStatus) }}
          </div>
          <!--待改约-->
          <div
            v-if="scope.row.OrderStatus == 30"
            style="color:#FFEB3B;font-weight:bold;"
          >
            {{ format.orderStatusFormat(scope.row.OrderStatus) }}
          </div>
          <!--已派单-->
          <div v-if="scope.row.OrderStatus == 40" style="color:#FF9800;font-weight:bold;">
            {{ format.orderStatusFormat(scope.row.OrderStatus) }}
          </div>
          <!--商家已服务-->
          <div
            v-if="scope.row.OrderStatus == 50"
            style="color:#2E7D32;font-weight:bold;"
          >
            {{ format.orderStatusFormat(scope.row.OrderStatus) }}
          </div>
           <!--已结算-->
          <div
            v-if="scope.row.OrderStatus == 70"
            style="color: #9C27B0;font-weight:bold;"
          >
            {{ format.orderStatusFormat(scope.row.OrderStatus) }}
          </div>
          <!--已拒绝-->
          <div
            v-if="scope.row.OrderStatus == 80"
            style="color:#F44336;font-weight:bold;"
          >
            {{ format.orderStatusFormat(scope.row.OrderStatus) }}
          </div>
          <!--已取消-->
          <div
            v-if="scope.row.OrderStatus == 90"
            style="color: #9E9E9E;font-weight:bold;"
          >
            {{ format.orderStatusFormat(scope.row.OrderStatus) }}
          </div>
          <div
            style="color:#9C27B0; font-weight: bold"
            v-if="scope.row.UserCompleted"
          >
            用户已核销
          </div>
          <span v-if="scope.row.UserCancelInfo && scope.row.UserCancelInfo.Key">
            {{ scope.row.UserCancelInfo.reason }}
          </span>
          <span v-if="scope.row.ShopCancelReason">
            {{ scope.row.ShopCancelReason }}
          </span>
          
        </template>
      </el-table-column>
      <el-table-column
        prop="Description"
        label="备注"
        :show-overflow-tooltip="true"
        min-width="150"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.UserComment" style="color:chocolate;font-weight:bold;"
            >用户：{{ scope.row.UserComment }}</div
          >
          <div v-if="scope.row.Description">
            <div v-for="desc in scope.row.Description.split('\n')" :key="desc">
              {{ desc }}
            </div>
          </div>
          <i
            class="el-icon-circle-plus"
            style="cursor: pointer; font-size: 18px; color: chocolate"
            @click="handleAddDesc(scope.row)"
          ></i>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120" align="center">
        <template slot-scope="scope">
          <el-dropdown
            @command="
              (command) => {
                handleCommand(command, scope.row);
              }
            "
          >
            <el-button type="info" size="medium">
              处理&nbsp;&nbsp;<i class="el-icon-menu"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <!-- <el-dropdown-item icon="el-icon-check" command="email"
                >邮件提醒</el-dropdown-item
              > -->
              <el-dropdown-item
                icon="el-icon-check"
                v-if="estimateOpr(scope.row, 'confirmBook')"
                command="confirmBook"
                >处理预定</el-dropdown-item
              >
              <el-dropdown-item
                icon="el-icon-circle-plus"
                v-if="estimateOpr(scope.row, 'confirmChange')"
                command="confirmChange"
                >处理改约</el-dropdown-item
              >
              <el-dropdown-item
                icon="el-icon-edit"
                command="changeBook"
                v-if="estimateOpr(scope.row, 'changeBook')"
                >修改预约</el-dropdown-item
              >
              <el-dropdown-item
                v-if="estimateOpr(scope.row, 'dispatch')"
                icon="el-icon-s-promotion"
                command="dispatch"
                >指派订单</el-dropdown-item
              >
              <el-dropdown-item
                icon="el-icon-success"
                command="Serviced"
                v-if="estimateOpr(scope.row, 'Serviced')"
                >完成服务</el-dropdown-item
              >
              <el-dropdown-item
                v-if="estimateOpr(scope.row, 'Balanced')"
                icon="el-icon-money"
                command="Balanced"
                >结算佣金</el-dropdown-item
              >
              <el-dropdown-item
                v-if="estimateOpr(scope.row, 'ServicedBalanced')"
                icon="el-icon-money"
                command="ServicedBalanced"
                >完成服务并结算</el-dropdown-item
              >
              <el-dropdown-item
                v-if="estimateOpr(scope.row, 'cancel')"
                icon="el-icon-error"
                command="cancel"
                >取消订单</el-dropdown-item
              >
              <!-- <el-dropdown-item
                icon="el-icon-refresh-left"
                v-if="estimateOpr(scope.row, 'revoke')"
                command="revoke"
                >撤销券码</el-dropdown-item
              > -->
              <el-dropdown-item
                icon="el-icon-delete-solid"
                v-if="estimateOpr(scope.row, 'delete')"
                command="delete"
                >删除订单</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="pageSizesList"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :current-page.sync="pageIndex"
      ></el-pagination>
    </div>
    <addDesc ref="addDesc" />
    <confirmBook ref="confirmBook" @update="updateData" />
    <confirmChangeBook ref="confirmChangeBook" @update="updateData" />
    <changeBook ref="changeBook" @update="updateData" />
    <dispatch ref="dispatch" @update="updateData" />
    <completedOrder ref="completedOrder" @update="updateData" />
    <cancelOrder ref="cancelOrder" @update="updateData" />
    <viewOrderInfo ref="viewOrderInfo" />
  </div>
</template>
  <script>
import {
  getPageList,
  deleteObj,
  exportOrder,
  testSendEmail,
} from "@/api/bussiness/order";
import orderEditor from "./orderEditor.vue";
import addDesc from "@/components/addDesc";
import confirmBook from "./confirmBook.vue";
import changeBook from "./changeBook.vue";
import confirmChangeBook from "./confirmChangeBook.vue";
import dispatch from "./dispatchOrder.vue";
import completedOrder from "./completedOrder.vue";
import cancelOrder from "./cancelOrder.vue";
import viewOrderInfo from "./viewOrderInfo.vue";
export default {
  components: {
    orderEditor,
    addDesc,
    confirmBook,
    confirmChangeBook,
    changeBook,
    dispatch,
    completedOrder,
    cancelOrder,
    viewOrderInfo,
  },
  props: {
    filter: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    filter: {
      handler(val) {
        this.pageIndex = 1;
        this.getData();
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_API,
      loadInstance: "",
      tableData: [],
      total: 0,
      pageIndex: 1,
      pageSize: 10,
      pageSizesList: [5, 10, 15, 20, 30, 50],
    };
  },
  methods: {
    calculateLiRun(row) {
      let amount =
        row.TotalAmount -
        (row.TotalAmount * row.Tenant.PlatChargeRate) / 100 -
        row.WorkerCommission -
        row.WorkerBonos;
      return amount.toFixed(2);
    },
    estimateOpr(row, command) {
      //用户预定..确认预约
      if (command == "confirmBook") {
        return row.OrderStatus == 10;
      }
      //改约中..确认改约
      if (command == "confirmChange") {
        return row.OrderStatus == 30;
      }
      //已预约或已派单..都可以改约
      if (command == "changeBook") {
        return row.OrderStatus == 20 || row.OrderStatus == 40;
      }
      //已预约或已派单..都可以改派
      if (command == "dispatch") {
        return row.OrderStatus == 20 || row.OrderStatus == 40;
      }
      //已派单..可以进行服务完成
      if (command == "Serviced") {
        return row.OrderStatus == 40;
      }
      //已派单..可以进行服务完成并结算
      if (command == "ServicedBalanced") {
        return row.OrderStatus == 40;
      }
      //商家服务已完成或用户已核销或已结算..可以进行结算
      if (command == "Balanced") {
        return (
          row.OrderStatus == 50 ||
          row.OrderStatus == 60 ||
          row.OrderStatus == 70
        );
      }
      //拒绝或取消..可以进行删除
      if (command == "delete") {
        return row.OrderStatus == 80 || row.OrderStatus == 90;
      }
      //已预约，已派单，已完成（为了支持用户协商退款）..可以进行取消
      if (command == "cancel") {
        return (
          row.OrderStatus == 20 ||
          row.OrderStatus == 40 ||
          row.OrderStatus == 50
        );
      }
      //已取消可以撤销券码
      if (command == "revoke") {
        return row.OrderStatus == 90;
      }
      return false;
    },
    showInfo(row) {
      this.$refs.viewOrderInfo.show(row);
    },
    onCopy(row, short) {
      let name = row.UserAddress.receiver_name;
      let mobile = row.UserAddress.receiver_mobile
        ? row.UserAddress.receiver_mobile
        : row.UserAddress.receiver_phone;
      let adrees = row.UserAddress.receiver_address;
      let content = row.ProductName;
      if (content.indexOf("】") > 0) {
        content = content.substring(0, content.indexOf("】") + 1);
      }
      let quantity = row.Quantity;
      let date = this.format.dateMonthDayFormat(row.BeginTime);
      let text = date + "\r\n";
      text += "【" + quantity + "】*" + content + "\r\n";
      if (!short) {
        text += adrees + "\r\n";
        text += mobile + "\r\n";
        text += "门店：" + row.Tenant.Name;
      } else {
        text += adrees + "\r\n";
      }
      this.$copyText(text).then(
        (e) => {
          this.msg.successMsg("复制成功");
        },
        (e) => {
          this.msg.errorMsg("复制失败");
        }
      );
    },
    handleCommand(command, row) {
      if (command == "email") {
        let parma = { key: row.Key };
        testSendEmail(parma);
      }
      if (command == "confirmBook") {
        this.$refs.confirmBook.show(row);
      }
      if (command == "confirmChange") {
        this.$refs.confirmChangeBook.show(row);
      }
      if (command == "changeBook") {
        this.$refs.changeBook.show(row);
      }
      if (command == "dispatch") {
        this.$refs.dispatch.show(row);
      }
      if (
        command == "Balanced" ||
        command == "Serviced" ||
        command == "ServicedBalanced"
      ) {
        this.$refs.completedOrder.show(row, command);
      }
      if (command == "delete") {
        this.handleDelete(row);
      }
      if (command == "cancel") {
        this.$refs.cancelOrder.show(row);
      }
    },
    handleAddDesc(row) {
      this.$refs["addDesc"].Show(row, "Order");
    },
    //查看
    handleView(row) {
      this.$refs.orderEditor.handleView(row);
    },
    //新增
    handleCreate() {
      this.$refs.orderEditor.handleCreate();
    },
    //修改
    handleUpdate(row) {
      this.$refs.orderEditor.handleUpdate(row);
    },
    //删除
    handleDelete: function (row) {
      this.$confirm("删除订单后将无法找回，确认删除该订单吗?", "提示", {
        type: "warning",
      }).then(() => {
        let para = { key: row.Key };
        deleteObj(para).then((response) => {
          if (response) {
            this.msg.successMsg("操作成功");
            this.getData();
          }
        });
      });
    },
    handleExport() {
      this.filter.pageIndex = this.pageIndex;
      this.filter.pageSize = this.pageSize;
      this.loadInstance = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      exportOrder(this.filter)
        .then((res) => {
          this.loadInstance.close();
          if (res) {
            window.open(this.baseUrl + res);
          }
        })
        .catch((ex) => {
          this.errorMsg("导出出错：" + ex);
          this.loadInstance.close();
        });
    },
    updateData() {
      this.getData();
      this.$emit("update");
    },
    getData() {
      this.filter.pageIndex = this.pageIndex;
      this.filter.pageSize = this.pageSize;
      getPageList(this.filter).then((response) => {
        if (response) {
          this.tableData = response.Items;
          this.total = response.Total || response.Items.length;
          this.$emit("load");
        }
      });
    },

    handleSizeChange(val) {
      var pageSize = val;
      this.pageIndex = 1;
      this.pageSize = parseInt(pageSize);
      this.$nextTick(() => this.getData());
    },

    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getData();
    },
  },
  mounted() {
    //this.getData();
  },
};
</script>
  <style lang='scss' scoped>
.status {
  align-self: flex-end;
  font-size: 12px;
  font-weight: bold;
  color: #ff862f;
}
.statusdesc {
  align-self: flex-end;
  font-size: 12px;
  color: #797878;
}
.pagination {
  margin-top: 10px;
  text-align: right;
}
.link {
  color: #268bd2;
  text-decoration: underline;
  cursor: pointer;
}
</style>